 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const ProcessModelWithComponentsByModelId = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.ProcessModelWithComponentsByModelId,
   method: RequestType.POST,
   data,
 });  

const ProductTransferCommand = {
  ProcessModelWithComponentsByModelId
}

export default ProductTransferCommand;
